import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NotificationManager } from 'react-notifications';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Overlay,
} from '@ami/react/core';
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavbarToggler,
} from 'reactstrap';
import { Button } from 'reactstrap';
import { ordersService } from '../../../ordersService';
import {
  OrderView,
  ShipmentStatus,
} from '../../../order';
import { ProductConfiguration } from '../../../../products/productConfiguration';
import DndShipment from './DndShipment';
import OrderShipmentComponent from './OrderShipmentComponent';
import { Modal } from '@ami/react/core';

import OrderShipmentModal from '../../../../../.././../management/src/lib/components/orders/Shipments/OrderShipmentModal';

const RemoveConfirmationModal = ({
  shipment,
  onShowUpdated,
  onConfirm,
  submitting,
}) => {
  return (
    <Modal
      title="Confirm Delete"
      show={true}
      onShowUpdated={onShowUpdated}
      okTitle="Yes"
      cancelTitle="No"
      onOk={onConfirm}
      showCancel={true}
      submitting={submitting}
      closeOnOk={false}
    >
      <p>
        Are you sure you want to confirm the deletion of the following shipment?
      </p>
      <strong>
      { shipment.name}
      </strong>
    </Modal>
  )
};

class ManageShipmentComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {    
      saving: false,
      order:this.props.order,
      editingId: undefined,
      shipmentToDelete: undefined,
      removing: false,
    };

    this.handleShipmentCancel = this.handleShipmentCancel.bind(this);  
    this.orderShipmentModalRef = React.createRef();  
    this.handleShipmentSave = this.handleShipmentSave.bind(this);
  }

  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    onChanged: PropTypes.func.isRequired,
    onCancel:  PropTypes.func.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
  };


  componentDidUpdate(prevProps) {
    if (prevProps.order !== this.props.order) {
      this.setState({
        order: this.props.order,
      });
    }
  }


  save = () => {
    this.setState({ saving: true });

    const data = this.state.order.shipments.map((x) => ({
      shipmentId: x.id,
      name:x.name,
      customLocation:x.customLocation,
      customInstruction: x.customInstruction,
      shipmentDate: x.shipmentDate,
      lineItemIds: this.state.order.lineItems
        .filter((y) => y.shipmentId === x.id)
        .map((y) => y.id),
    }));
    const shipmentsWithoutProducts = data.filter((x) => x.lineItemIds.length === 0);  
    if (shipmentsWithoutProducts.length>0) {   
      NotificationManager.error('Shipment '+  shipmentsWithoutProducts.map((shipment) => shipment.name).join(', ') +' requires at least 1 product');
      this.setState({ saving: false });
      return;
    }  

    const groupedShipments = data.reduce((acc, shipment) => {
      const name = shipment.name;
      acc[name] = (acc[name] || []).concat(shipment);
      return acc;
    }, {}); 
    const hasDuplicateNames = Object.values(groupedShipments).some(group => group.length > 1)
    if(hasDuplicateNames) {
      NotificationManager.error('Please enter a unique shipment name');
      this.setState({ saving: false });
      return;
    }

    ordersService
      .updateShipments(
        this.props.order.id,
        data.filter((x) => x.lineItemIds.length > 0)
      )
      .then(() => {
        this.props.onChanged();      
      })
      .finally(() => this.setState({ saving: false }));

  };

  moveProduct = (productId, shipmentId) => {
    const { order } = this.state;
    const lineItem = order.lineItems.find((x) => x.id === productId);
    lineItem.shipmentId = shipmentId;
    this.setState({ order });
  };

 
  handleAddShipment(newShipment) {
    const { order } = this.state;
    newShipment.id = order.shipments.reduce(function (maxId, item) {
      return Math.max(maxId, item.id) + 1;
    }, 0);
    order.shipments = [...order.shipments, newShipment];
    this.setState({ order, editingId: undefined });
  }

  handleShipmentSelect(shipment) {
    this.setState({ editingId: shipment.id });
    this.orderShipmentModalRef.current.edit(shipment)
  }

  handleShipmentCancel() {    
    this.setState({ editingId: undefined });
  }

  handleShipmentEdit(shipment) {   
    const { order } = this.state;
    const index = order.shipments.findIndex(({ id }) => id === shipment.id);
    order.shipments = [
      ...order.shipments.slice(0, index),
      shipment,
      ...order.shipments.slice(index + 1),
    ];
    this.setState({ order, editingId: undefined });
  }

  handleOnRemove = (shipmentToDelete) => {
    this.setState({ shipmentToDelete });
  };

  handleShipmentSave(shipment, edited) {    
     if (edited) this.handleShipmentEdit(shipment);
     else  this.handleAddShipment(shipment);     
   }


  remove = () => {
    const { shipmentToDelete } = this.state;
    const { order } = this.state;
    order.shipments = order.shipments.filter(
      (x) => x.id !== shipmentToDelete.id
    );
    this.setState({ order, shipmentToDelete: undefined });
  };

  render() {
    const {  order, editingId } = this.state;      
    return (
       <div >     
              <Navbar color="dark" dark expand="md" className="order-header">
         <div className="row">
           <div className="col-lg-6">
           <NavbarBrand>
              <h2 className="page-title">
                <div title={order.name}>{order.name}</div>
                <div className="subtitle pull-left mt-1 me-2">
                  Order {order.workOrderNumber}, PO {order.poNumber}
                </div>             
              </h2>
              </NavbarBrand>
              </div> 
              <div className="col-lg-6">
              <Nav className="order-nav" navbar>
              <div className="row buttons-wrapper justify-content-end">
              <NavItem>
                  <Button
                    children="Add Shipment"
                    color="primary"
                    onClick={() => this.orderShipmentModalRef.current.edit()}     
                    className="w-100 mt-4"
                  />
                   </NavItem>
               </div>
               </Nav>
              </div>    
          </div>   
          </Navbar>
          <div className="hr-divider">
            <h3 className="hr-divider-content hr-divider-heading">
            Manage Shipments
            </h3>
          </div>       
        
          <div className="row">       
            <div className="col order-shipments">
              {order.shipments.map((shipment, index) => (
                <div key={index}>
                  {shipment.status !== ShipmentStatus.Shipped && (
                    <Fragment>                                
                      <DndShipment
                        shipment={shipment}
                        moveProduct={this.moveProduct}
                        order={order}
                        productConfiguration={this.props.productConfiguration}
                        onSelect={() => this.handleShipmentSelect(shipment)}
                        onRemove={() => this.handleOnRemove(shipment)}
                        loadOrder={this.props.onChanged}
                      />
                    </Fragment>
                  )}
                  {shipment.status === ShipmentStatus.Shipped && (
                    <div className="mb-3">
                      <OrderShipmentComponent
                        order={order}
                        shipment={shipment}
                        onConfirmDateButtonClicked={() => { }}
                        onMarkShippedButtonClicked={() => { }}
                        onUnshipButtonClicked={() => { }}
                        canChangeStatus={false}
                        productConfiguration={this.props.productConfiguration}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>       

          <div className="row mt-2 mb-4">
          <div className="col text-end">
            <div className="clearfix">
              <div className="pull-right">              
                  <Button
                    children="Cancel"
                    color="secondary"
                    className="btn-lg ms-3 mb-2"
                    onClick={this.props.onCancel}
                    type="button"
                  />              
                 <Button
                  children={
                    this.state.saving ? (
                      <span>
                        <i className="fa fa-spin fa-spinner" /> Saving
                      </span>
                    ) : (
                      <span>Save</span>
                    )
                  }            
                    color="success"
                    className="btn-lg ms-3 mb-2"
                    onClick={this.save}
                    disabled={this.state.saving}
                  />  
              </div>
            </div>
          </div>
        </div>        
          {this.state.shipmentToDelete && (
            <RemoveConfirmationModal
              shipment={this.state.shipmentToDelete}
              onShowUpdated={(show) => {
                if (!show) this.setState({ shipmentToDelete: undefined });
              }}
              onConfirm={this.remove}
              submitting={this.state.removing}
            />
          )} 
          <OrderShipmentModal
              ref={this.orderShipmentModalRef}
              selectedDealerBranch={ { label : order.dealerInformation.dealerBranchName }}                 
              shipmmentCount={order.shipments.length + 1}
              shipments ={ order.shipments}
              onShipmentSave={this.handleShipmentSave}           
            />
    </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(ManageShipmentComponent);
